
const initState = {
  modal: false,
  modalBanner: false
}
export default (state = initState, action) => {
  switch (action.type) {
    case 'TOGGLE_MODAL':
      return { ...action }
    case 'TOGGLE_MODAL_BANNER':
      return { ...action }
    default:
      return state
  }
}